import React from 'react'
import styles from './CuePopup.scss'
import { Popup } from 'common/Map/Popup'
import { withFocus } from 'common/Map/MapFocusContext'

class _CuePopup extends React.PureComponent {
  componentDidMount = () => {
    this.grabFocus()
  }

  componentDidUpdate (prevProps) {
    const { coursePoint } = this.props
    if (coursePoint.i !== prevProps.coursePoint.i) {
      this.grabFocus()
    }
  }

  grabFocus = () => {
    const { setFocus } = this.props
    setFocus(this.focusId())
  }

  focusId = () => {
    const { coursePoint } = this.props
    return `coursePoint-${coursePoint.i}`
  }

  hasFocus = () => {
    return this.focusId() === this.props.mapFocusId
  }

  onRequestClose = () => {
    const { setFocus, onRequestClose } = this.props
    setFocus(null)
    onRequestClose && onRequestClose()
  }

  render () {
    const { coursePoint, autoPan } = this.props
    const focused = this.hasFocus()

    if (!focused) { return null }

    return (
      <Popup
        onRequestClose={this.onRequestClose}
        closeButton
        position={{ lat: coursePoint.y, lng: coursePoint.x }}
        autoPan={autoPan}
        maxWidth={200} minWidth={50}>
        <div className={styles.CuePopup}>
          {coursePoint.n}
        </div>
      </Popup>
    )
  }
}

export const CuePopup = withFocus(_CuePopup)
